/*
 * Purpose: Sync --mission-map-tools-sticky-top for map tools row under sticky nav
 * Last modified: 2026-07-10 | Agent
 * Completeness: 95
 */
import { useLayoutEffect, type RefObject } from 'react';

const NAV_SELECTOR = '.ab-mission-nav--map-sticky';

export function useMissionMapToolsStickyTop(scrollRootRef: RefObject<HTMLElement | null>) {
  useLayoutEffect(() => {
    const root = scrollRootRef.current;
    if (!root) return;

    const nav = root.querySelector(NAV_SELECTOR);
    if (!(nav instanceof HTMLElement)) return;

    let lastOffset = '';

    const sync = () => {
      const navHeight = Math.ceil(nav.getBoundingClientRect().height);
      const newValue = `calc(var(--app-top-offset, 3.5rem) + ${navHeight}px)`;
      if (newValue !== lastOffset) {
        lastOffset = newValue;
        document.documentElement.style.setProperty(
          '--mission-map-tools-sticky-top',
          newValue
        );
      }
    };

    sync();
    const ro = new ResizeObserver(sync);
    ro.observe(nav);
    window.addEventListener('resize', sync);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', sync);
      document.documentElement.style.removeProperty('--mission-map-tools-sticky-top');
    };
  }, [scrollRootRef]);
}
